import type { MatchState } from './types';

/**
 * mulberry32. `seed` is the state *before* the step; the returned seed is stored
 * on the match and is the input to the next call.
 */
export function nextUint(seed: number): { seed: number; value: number } {
  let a = seed | 0;
  a = (a + 0x6d2b79f5) | 0;
  let t = Math.imul(a ^ (a >>> 15), 1 | a);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return {
    seed: a >>> 0,
    value: ((t ^ (t >>> 14)) >>> 0) / 4294967296,
  };
}

export function rngNext(state: MatchState): number {
  const step = nextUint(state.rngState);
  state.rngState = step.seed;
  return step.value;
}

/** Integer in `[0, max)`. */
export function rngInt(state: MatchState, max: number): number {
  return Math.floor(rngNext(state) * max);
}

/** External RNG for bots. Does not touch match state, so replays stay pure. */
export interface Rng {
  next(): number;
  int(max: number): number;
}

export function createRng(seed: number): Rng {
  let s = seed >>> 0;
  return {
    next() {
      const step = nextUint(s);
      s = step.seed;
      return step.value;
    },
    int(max: number) {
      return Math.floor(this.next() * max);
    },
  };
}
